import { getTranslationMessage } from '@/services/translation';
import { LANG, BACKUP_LOCALE, MOMENT_LANG } from './locale';
import dateLib from './dateLib/moment';
import reporter from './report';
import { loadJS, generateBaseDomain } from '@/utils/loadUtil';
import intl from '@/utils/i18n';
import cache from '@/utils/cache';

// 必须用一个函数来触发 dynamic import 的 partial import
function getMomentLanguage() {
  return MOMENT_LANG;
}

export function setMomentLocales() {
  if (!dateLib.getLocales().includes(MOMENT_LANG)) {
    import(
    /* webpackInclude: /\.js$/ */
    /* webpackChunkName: "moment-locale-" */
    /* webpackPreload: true */
      `./dateLib/locale/${getMomentLanguage()}.js`
    ).then(() => {
      console.log('current moment locale: ', MOMENT_LANG);
      dateLib.setLocale(MOMENT_LANG);
    }).catch((err) => {
      console.error(err);
      reporter.apiLog(err?.message);
      dateLib.setLocale(BACKUP_LOCALE);
    });
  }
}

export const setLocales = async () => {
  const backupLocale = LANG === BACKUP_LOCALE ? '' : BACKUP_LOCALE;

  setMomentLocales();

  let i18nMessages;
  // 当前地区对应语言
  i18nMessages = await getTranslationMessage(LANG).catch(async () => undefined);
  if (!i18nMessages) {
    // 备用语言（en）
    i18nMessages = await getTranslationMessage(backupLocale).catch(async () => undefined);
  }

  const result = { [LANG]: i18nMessages || {}};

  return result;
};

export function pullAllTranslation() {
  const transifyKey = window.ShopeeChatbot.transifyKey;

  const prefix = `${transifyKey != null ? transifyKey + '_' : ''}${LANG}`;

  const timeStamp = cache.local.getItem(`${prefix}_time_stamp`);
  const shouldPullTranslation = window.chatbotGlobalInfo?.shouldPullTranslation;
  if (shouldPullTranslation || !timeStamp) {
    // 异步获取全量key 用途(1)兜底(2)localStorage缓存
    loadJS(`${generateBaseDomain()}static/translation/${transifyKey != null ? transifyKey + '/' : ''}${LANG}.js?v=${+new Date()}`, () => {
      if (window.chatbotGlobalInfo?.allTranslation) {
        cache.local.setItem(`${prefix}_time_stamp`, 1, 600);
        cache.local.setItem(`${prefix}_version`, window.chatbotGlobalInfo.translationVersion);
        const translation = window.chatbotGlobalInfo.allTranslation;
        cache.local.setItem(`${prefix}_translation`, translation);
        intl.setLocales(translation);
      }
    });
  }
}
